import script from "./quick-filter-wrapper.vue?vue&type=script&setup=true&lang=ts"
export * from "./quick-filter-wrapper.vue?vue&type=script&setup=true&lang=ts"

import "./quick-filter-wrapper.vue?vue&type=style&index=0&id=f187cf0e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f187cf0e"]])

export default __exports__